/**
 * Created by Administrator on 2017/4/9.
 */

export default {
  getCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return unescape(c.substring(nameEQ.length, c.length));
      }
    }
    return false;
  },

  removeCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      if (cookies[i].indexOf(' ') === 0) {
        cookies[i] = cookies[i].substring(1);
      }
      if (cookies[i].indexOf(name) === 0) {
        const exp = new Date();
        exp.setTime(exp.getTime() - 60 * 1000);
        document.cookie = `${cookies[i]};expires=${exp.toUTCString()}`;
        break;
      }
    }
  },
};
